import React, { useCallback, useEffect, useMemo, useState, useRef, createElement, Component } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Toggle } from '../components/ui/Toggle';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { Download, Layers, Users, Home, Database, X, Filter, BarChart3, PieChart as PieChartIcon, SlidersHorizontal, GripVertical, RotateCcw } from 'lucide-react';
// Embedded Data
const rawData = [{
  id: '0b41bf0e',
  buyerId: 'a5e3909d',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Backsplash',
  variant: 'Villa Centura Ocean',
  date: '02/06/2026'
}, {
  id: 'c19cdac7',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Backsplash',
  variant: 'Villa Centura Fawn',
  date: '02/06/2026'
}, {
  id: '3b25b395',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Backsplash',
  variant: 'Villa Centura White',
  date: '02/06/2026'
}, {
  id: '8d30e5c6',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Backsplash',
  variant: 'Artisan Square White',
  date: '02/06/2026'
}, {
  id: 'bef639be',
  buyerId: 'a5e3909d',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Backsplash',
  variant: 'Villa Centura Ocean',
  date: '02/06/2026'
}, {
  id: '80d2a8ae',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'Layouts',
  lvsName: 'Plan Options',
  variantSet: 'Basement',
  variant: '2 Bedroom Suite 2',
  date: '02/06/2026'
}, {
  id: 'fbf2e939',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'Layouts',
  lvsName: 'Plan Options',
  variantSet: 'Basement',
  variant: 'One Bedroom',
  date: '02/06/2026'
}, {
  id: 'f353a50f',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Cabinet Finish',
  variant: 'River Green',
  date: '02/06/2026'
}, {
  id: 'cf8d7b06',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Cabinet Profile',
  variant: 'Slab',
  date: '02/06/2026'
}, {
  id: 'de88bf0d',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Cabinet Profile',
  variant: 'Micro Shaker',
  date: '02/06/2026'
}, {
  id: '9bdc0d2b',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Carpet',
  variant: 'Sea Point Castleberry',
  date: '02/06/2026'
}, {
  id: '11172190',
  buyerId: 'af9151e3',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Carpet',
  variant: 'Upgrade to LVP',
  date: '02/06/2026'
}, {
  id: '39692a5c',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Carpet',
  variant: 'Castleberry',
  date: '02/06/2026'
}, {
  id: '2590edf6',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Carpet',
  variant: 'Head Start Ocean Mist',
  date: '02/06/2026'
}, {
  id: '22f5b1e5',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Carpet',
  variant: 'Head Start August Grove',
  date: '02/06/2026'
}, {
  id: '37bf50e0',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Carpet',
  variant: 'Head Start Gravel Stone',
  date: '02/06/2026'
}, {
  id: 'cfa097a2',
  buyerId: 'a5e3909d',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Countertop',
  variant: 'Elegant White',
  date: '02/06/2026'
}, {
  id: '941a75f3',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Countertop',
  variant: 'Carbon',
  date: '02/06/2026'
}, {
  id: 'cd8b4b47',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Countertop',
  variant: 'Elegant White',
  date: '02/06/2026'
}, {
  id: '394704d8',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Countertop',
  variant: 'Thunder Grey',
  date: '02/06/2026'
}, {
  id: '45a6672e',
  buyerId: 'a5e3909d',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Countertop',
  variant: 'Oyster Shell',
  date: '02/06/2026'
}, {
  id: 'f4934a26',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Dishwasher',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '6beaf377',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Dishwasher',
  variant: 'Level 2',
  date: '02/06/2026'
}, {
  id: 'bf209cc3',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Handle',
  variant: 'Katella',
  date: '02/06/2026'
}, {
  id: '722fbe49',
  buyerId: 'af9151e3',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Handle',
  variant: 'Prague',
  date: '02/06/2026'
}, {
  id: '2b797fa5',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Handle',
  variant: 'Halifax',
  date: '02/06/2026'
}, {
  id: '777853db',
  buyerId: 'af9151e3',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Handle Finish',
  variant: 'Brushed Chrome',
  date: '02/06/2026'
}, {
  id: '747226f3',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Handle Finish',
  variant: 'Satin Nickel',
  date: '02/06/2026'
}, {
  id: 'c13a7673',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Handle Finish',
  variant: 'Matte Black',
  date: '02/06/2026'
}, {
  id: '602b4bff',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Style',
  variant: 'Single Panel',
  date: '02/06/2026'
}, {
  id: '84fb78d1',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Style',
  variant: 'Two Panel Square Top',
  date: '02/06/2026'
}, {
  id: '8d57f94d',
  buyerId: 'af9151e3',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'Door Style',
  variant: 'Two Panel Square Top',
  date: '02/06/2026'
}, {
  id: '26d946c3',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Ensuite',
  variant: 'Level Two',
  date: '02/06/2026'
}, {
  id: '4de3a259',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Faucet',
  variant: 'Upgrade',
  date: '02/06/2026'
}, {
  id: '19dc2d3e',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Faucet Finish',
  variant: 'Matte Black',
  date: '02/06/2026'
}, {
  id: 'dd54107b',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Fixture Finish',
  variant: 'Champagne Bronze',
  date: '02/06/2026'
}, {
  id: '7200a1c9',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Fixtures',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '3697c992',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Fixtures',
  variant: 'Upgrade',
  date: '02/06/2026'
}, {
  id: 'dcdc57dc',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Flooring',
  variant: 'Upgrade to Tile',
  date: '02/06/2026'
}, {
  id: '5bb85f87',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Hood Fan',
  variant: 'Black',
  date: '02/06/2026'
}, {
  id: '11727804',
  buyerId: 'a5e3909d',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'LVP',
  variant: 'Willow',
  date: '02/06/2026'
}, {
  id: 'dc5437f8',
  buyerId: 'af9151e3',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'LVP',
  variant: 'Into the Wild',
  date: '02/06/2026'
}, {
  id: 'bb484a93',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'LVP',
  variant: 'Labyrinth',
  date: '02/06/2026'
}, {
  id: '8eb0d924',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'LVP',
  variant: 'Chasing Ice',
  date: '02/06/2026'
}, {
  id: 'e4d4a2c6',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'LVP',
  variant: 'Whispered Herringbone',
  date: '02/06/2026'
}, {
  id: '55f9c5f8',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'General',
  variantSet: 'LVP',
  variant: 'Whispered Herringbone',
  date: '02/06/2026'
}, {
  id: '37023119',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Laundry',
  variantSet: 'Laundry',
  variant: 'Black',
  date: '02/06/2026'
}, {
  id: '0e761ec9',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Laundry',
  variantSet: 'Laundry',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'e2e279a5',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'BASEMENT OPTIONS',
  lvsName: 'Laundry',
  variantSet: 'Laundry',
  variant: 'Black',
  date: '02/06/2026'
}, {
  id: '4dfa8b9e',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Layout',
  variant: 'Level Two',
  date: '02/06/2026'
}, {
  id: 'd7bbdc21',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Layout',
  variant: 'Level Three',
  date: '02/06/2026'
}, {
  id: 'b1b3dda6',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Layout',
  variant: 'Level Three',
  date: '02/06/2026'
}, {
  id: '776d81f2',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Light Fixtures',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'f6d70ffc',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Lower Cabinet Finish',
  variant: 'Free Spirit',
  date: '02/06/2026'
}, {
  id: '9d6650bf',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'dfa9990c',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'Layouts',
  lvsName: 'Plan Options',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'bf36f333',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '5716cdd1',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'Layouts',
  lvsName: 'Plan Options',
  variantSet: 'Main Floor',
  variant: 'Full Bath + Spice Kitchen',
  date: '02/06/2026'
}, {
  id: 'febc4fe3',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '7244f43a',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'b139b8ef',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'e0efc7de',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'cae1662c',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'b60649c8',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'Layouts',
  lvsName: 'Plan Options',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '0f815e56',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Plan Options',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'cb9b37fd',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Plan Options',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '50587f88',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Plan Options',
  variantSet: 'Main Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '425f52a7',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Microwave',
  variant: 'Black',
  date: '02/06/2026'
}, {
  id: '5e2d6115',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Options',
  variant: 'Elevation P',
  date: '02/06/2026'
}, {
  id: '379bcace',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Options',
  variant: 'Elevation AC',
  date: '02/06/2026'
}, {
  id: '8e06e62c',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Options',
  variant: 'Elevation P',
  date: '02/06/2026'
}, {
  id: 'df1f8843',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Options',
  variant: 'Elevation U',
  date: '02/06/2026'
}, {
  id: '08849ee4',
  buyerId: 'af9151e3',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Options',
  variant: 'Elevation CE',
  date: '02/06/2026'
}, {
  id: 'f35e263d',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Inspirations',
  variantSet: 'Palettes',
  variant: 'Palette B9',
  date: '02/06/2026'
}, {
  id: 'b02a1286',
  buyerId: 'af9151e3',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Inspirations',
  variantSet: 'Palettes',
  variant: 'Palette B1',
  date: '02/06/2026'
}, {
  id: '03881592',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'FINISHES',
  variantSet: 'Palettes',
  variant: 'Palette B2',
  date: '02/06/2026'
}, {
  id: 'b9ea82ca',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Inspirations',
  variantSet: 'Palettes',
  variant: 'Palette B10',
  date: '02/06/2026'
}, {
  id: 'd58963c3',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Pedestal Sink',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: '2a76e95e',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Pot Filler',
  variant: 'Add Pot Filler',
  date: '02/06/2026'
}, {
  id: 'd55a649d',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Railing',
  variant: 'Level Two',
  date: '02/06/2026'
}, {
  id: '1321b8b0',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Railing Profile',
  variant: '7+2 Series',
  date: '02/06/2026'
}, {
  id: 'b610cb63',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Range Oven',
  variant: 'Level 3',
  date: '02/06/2026'
}, {
  id: '5f28464c',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Range Oven',
  variant: 'Level 3',
  date: '02/06/2026'
}, {
  id: '7eccad3d',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Refrigerator',
  variant: 'Smart Appliance Refrigerator',
  date: '02/06/2026'
}, {
  id: 'dabfd14e',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Refrigerator',
  variant: 'Level 2',
  date: '02/06/2026'
}, {
  id: '99d04500',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Sink',
  variant: 'Dual Undermount',
  date: '02/06/2026'
}, {
  id: '29bd6a55',
  buyerId: 'e73ab742',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Sink',
  variant: 'Dual Undermount',
  date: '02/06/2026'
}, {
  id: '150d9120',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Sink Finish',
  variant: 'White',
  date: '02/06/2026'
}, {
  id: '348d8f73',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Tile and Backsplash',
  variant: 'Travertine Grey',
  date: '02/06/2026'
}, {
  id: '215a127b',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Bathroom',
  variantSet: 'Tile and Backsplash',
  variant: 'Divine Cream',
  date: '02/06/2026'
}, {
  id: 'd9c9fdc9',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Upper Cabinet Finish',
  variant: 'Free Spirit',
  date: '02/06/2026'
}, {
  id: '8f054985',
  buyerId: '602fd163',
  model: 'Collingwood',
  category: 'Layouts',
  lvsName: 'Plan Options',
  variantSet: 'Upper Floor',
  variant: 'Standard',
  date: '02/06/2026'
}, {
  id: 'f7a2d118',
  buyerId: '137fd703',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Kitchen',
  variantSet: 'Wall Oven',
  variant: 'Black',
  date: '02/06/2026'
}, {
  id: 'fa00d3aa',
  buyerId: 'a5e3909d',
  model: 'Collingwood',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Wall Paint',
  variant: 'Summit CA019',
  date: '02/06/2026'
}, {
  id: '639547ed',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Wall Paint',
  variant: 'Summit CA019',
  date: '02/06/2026'
}, {
  id: '83f53344',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Wall Paint',
  variant: 'Summit CA019',
  date: '02/06/2026'
}, {
  id: '488e4738',
  buyerId: '893ae8da',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'General',
  variantSet: 'Wall Paint',
  variant: 'Designer Grey CJ 231',
  date: '02/06/2026'
}, {
  id: 'd7dec7ed',
  buyerId: '336765a6',
  model: 'Bellevue',
  category: 'MAIN OPTIONS',
  lvsName: 'Elevations',
  variantSet: 'Wall Paint',
  variant: 'Summit CA019',
  date: '02/06/2026'
}];
// ─── Constants ──────────────────────────────────────────────────────────────────
const PIE_COLORS = ['#0ea5e9', '#06b6d4', '#14b8a6', '#10b981', '#22c55e', '#84cc16', '#eab308', '#f59e0b', '#f97316', '#ef4444'];
const toSentenceCase = (str: string) => str.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
// ─── Types ──────────────────────────────────────────────────────────────────────
type ChartType = 'bar' | 'pie';
type WidgetConfig = {
  id: string;
  label: string;
  visible: boolean;
};
const DEFAULT_WIDGETS: WidgetConfig[] = [{
  id: 'kpi-cards',
  label: 'KPI Summary Cards',
  visible: true
}, {
  id: 'top-variants',
  label: 'Top Variant Selections',
  visible: true
}, {
  id: 'summary-table',
  label: 'Selection Summary Table',
  visible: true
}, {
  id: 'room-charts',
  label: 'Room Option Charts',
  visible: true
}];
// ─── Custom Pie Label ───────────────────────────────────────────────────────────
const renderPieLabel = ({
  name,
  percent
}: {
  name: string;
  percent: number;
}) => {
  if (percent < 0.05) return null;
  return `${name.length > 14 ? name.slice(0, 12) + '…' : name} (${(percent * 100).toFixed(0)}%)`;
};
// ─── Customize Panel ────────────────────────────────────────────────────────────
function CustomizePanel({
  widgets,
  onToggle,
  onReorder,
  onReset,
  onClose
}: {
  widgets: WidgetConfig[];
  onToggle: (id: string) => void;
  onReorder: (fromIndex: number, toIndex: number) => void;
  onReset: () => void;
  onClose: () => void;
}) {
  const [dragIdx, setDragIdx] = useState<number | null>(null);
  const [overIdx, setOverIdx] = useState<number | null>(null);
  const handleDragStart = (e: React.DragEvent, index: number) => {
    setDragIdx(index);
    e.dataTransfer.effectAllowed = 'move';
    // Transparent drag image
    const el = document.createElement('div');
    el.style.opacity = '0';
    document.body.appendChild(el);
    e.dataTransfer.setDragImage(el, 0, 0);
    setTimeout(() => document.body.removeChild(el), 0);
  };
  const handleDragOver = (e: React.DragEvent, index: number) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setOverIdx(index);
  };
  const handleDrop = (e: React.DragEvent, index: number) => {
    e.preventDefault();
    if (dragIdx !== null && dragIdx !== index) {
      onReorder(dragIdx, index);
    }
    setDragIdx(null);
    setOverIdx(null);
  };
  const handleDragEnd = () => {
    setDragIdx(null);
    setOverIdx(null);
  };
  return <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-xl shadow-xl border border-slate-200 z-50 overflow-hidden" data-id="element-3153">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 bg-slate-50" data-id="element-3154">
        <h3 className="text-sm font-semibold text-slate-800" data-id="element-3155">
          Customize Dashboard
        </h3>
        <button onClick={onClose} className="p-1 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors" data-id="element-3156">
          <X className="h-4 w-4" data-id="element-3157" />
        </button>
      </div>
      <div className="p-2" data-id="element-3158">
        <p className="text-[11px] text-slate-400 px-2 py-1.5 uppercase tracking-wider font-medium" data-id="element-3159">
          Drag to reorder · Toggle visibility
        </p>
        <div className="space-y-0.5" data-id="element-3160">
          {widgets.map((widget, index) => <div key={widget.id} draggable onDragStart={e => handleDragStart(e, index)} onDragOver={e => handleDragOver(e, index)} onDrop={e => handleDrop(e, index)} onDragEnd={handleDragEnd} className={`flex items-center gap-2 px-2 py-2.5 rounded-lg transition-all cursor-grab active:cursor-grabbing select-none ${dragIdx === index ? 'opacity-40 scale-95' : ''} ${overIdx === index && dragIdx !== index ? 'bg-primary-50 ring-1 ring-primary-200' : 'hover:bg-slate-50'}`} data-id="element-3161">
              <GripVertical className="h-4 w-4 text-slate-300 flex-shrink-0" data-id="element-3162" />
              <span className={`flex-1 text-sm ${widget.visible ? 'text-slate-700 font-medium' : 'text-slate-400'}`} data-id="element-3163">
                {widget.label}
              </span>
              <Toggle checked={widget.visible} onChange={() => onToggle(widget.id)} label="" data-id="element-3164" />
            </div>)}
        </div>
      </div>
      <div className="px-4 py-3 border-t border-slate-100 bg-slate-50" data-id="element-3165">
        <button onClick={onReset} className="flex items-center gap-1.5 text-xs font-medium text-slate-500 hover:text-slate-700 transition-colors" data-id="element-3166">
          <RotateCcw className="h-3 w-3" data-id="element-3167" />
          Reset to Default
        </button>
      </div>
    </div>;
}
// ─── Chart Type Toggle ──────────────────────────────────────────────────────────
function ChartTypeToggle({
  value,
  onChange
}: {
  value: ChartType;
  onChange: (v: ChartType) => void;
}) {
  return <div className="flex items-center bg-slate-100 rounded-lg p-0.5" data-id="element-3168">
      <button onClick={() => onChange('bar')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${value === 'bar' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} title="Bar Chart" data-id="element-3169">
        <BarChart3 className="h-3.5 w-3.5" data-id="element-3170" />
        <span className="hidden sm:inline" data-id="element-3171">Bar</span>
      </button>
      <button onClick={() => onChange('pie')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all ${value === 'pie' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} title="Pie Chart" data-id="element-3172">
        <PieChartIcon className="h-3.5 w-3.5" data-id="element-3173" />
        <span className="hidden sm:inline" data-id="element-3174">Pie</span>
      </button>
    </div>;
}
// ─── Main Component ─────────────────────────────────────────────────────────────
export function AnalyticsDataPage() {
  // Check if we should force empty state (for testing)
  const forceEmptyState = window.location.pathname.includes('/empty');
  const showGenericEmpty = window.location.pathname.includes('/empty-2');
  // Filter State
  const [modelFilter, setModelFilter] = useState('All Models');
  const [selectedRoom, setSelectedRoom] = useState('All Rooms');
  // Customization State
  const [chartType, setChartType] = useState<ChartType>('bar');
  const [widgets, setWidgets] = useState<WidgetConfig[]>(DEFAULT_WIDGETS);
  const [customizeOpen, setCustomizeOpen] = useState(false);
  const customizeRef = useRef<HTMLDivElement>(null);
  // Close customize panel on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (customizeRef.current && !customizeRef.current.contains(e.target as Node)) {
        setCustomizeOpen(false);
      }
    };
    if (customizeOpen) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [customizeOpen]);
  // Reset selectedRoom when modelFilter changes
  useEffect(() => {
    setSelectedRoom('All Rooms');
  }, [modelFilter]);
  // Widget helpers
  const isWidgetVisible = useCallback((id: string) => widgets.find(w => w.id === id)?.visible ?? true, [widgets]);
  const handleToggleWidget = useCallback((id: string) => {
    setWidgets(prev => prev.map(w => w.id === id ? {
      ...w,
      visible: !w.visible
    } : w));
  }, []);
  const handleReorderWidgets = useCallback((fromIndex: number, toIndex: number) => {
    setWidgets(prev => {
      const next = [...prev];
      const [moved] = next.splice(fromIndex, 1);
      next.splice(toIndex, 0, moved);
      return next;
    });
  }, []);
  const handleResetWidgets = useCallback(() => {
    setWidgets(DEFAULT_WIDGETS);
  }, []);
  // Filter Logic
  const filteredData = useMemo(() => {
    return rawData.filter(item => {
      return modelFilter === 'All Models' || item.model === modelFilter;
    });
  }, [modelFilter]);
  // KPIs
  const kpis = useMemo(() => {
    const uniqueBuyers = new Set(filteredData.map(d => d.buyerId)).size;
    const uniqueModels = new Set(filteredData.map(d => d.model)).size;
    const typeCounts: Record<string, number> = {};
    filteredData.forEach(d => {
      typeCounts[d.variantSet] = (typeCounts[d.variantSet] || 0) + 1;
    });
    let topType = '-';
    let maxCount = 0;
    Object.entries(typeCounts).forEach(([type, count]) => {
      if (count > maxCount) {
        maxCount = count;
        topType = type;
      }
    });
    return {
      totalSelections: filteredData.length,
      uniqueBuyers,
      modelsActive: uniqueModels,
      topOptionType: topType
    };
  }, [filteredData]);
  // Room Navigation Data
  const roomNavData = useMemo(() => {
    const roomCounts: Record<string, number> = {};
    filteredData.forEach(d => {
      roomCounts[d.lvsName] = (roomCounts[d.lvsName] || 0) + 1;
    });
    return Object.entries(roomCounts).map(([name, count]) => ({
      name,
      count
    })).sort((a, b) => b.count - a.count);
  }, [filteredData]);
  // All Rooms Data
  const allRoomsData = useMemo(() => {
    const variantCounts: Record<string, number> = {};
    filteredData.filter(d => d.variant !== 'Standard').forEach(d => {
      variantCounts[d.variant] = (variantCounts[d.variant] || 0) + 1;
    });
    const topVariants = Object.entries(variantCounts).map(([name, value]) => ({
      name,
      value
    })).sort((a, b) => b.value - a.value).slice(0, 10);
    const groups: Record<string, {
      lvsName: string;
      variantSet: string;
      variant: string;
      count: number;
    }> = {};
    filteredData.forEach(item => {
      const key = `${item.lvsName}|||${item.variantSet}|||${item.variant}`;
      if (!groups[key]) {
        groups[key] = {
          lvsName: item.lvsName,
          variantSet: item.variantSet,
          variant: item.variant,
          count: 0
        };
      }
      groups[key].count += 1;
    });
    const summaryTable = Object.values(groups).sort((a, b) => b.count - a.count).slice(0, 15);
    return {
      topVariants,
      summaryTable
    };
  }, [filteredData]);
  // Specific Room Data
  const specificRoomData = useMemo(() => {
    if (selectedRoom === 'All Rooms') return [];
    const roomRows = filteredData.filter(d => d.lvsName === selectedRoom);
    const variantSets: Record<string, {
      variants: Record<string, number>;
      standardCount: number;
    }> = {};
    roomRows.forEach(d => {
      if (!variantSets[d.variantSet]) {
        variantSets[d.variantSet] = {
          variants: {},
          standardCount: 0
        };
      }
      if (d.variant === 'Standard') {
        variantSets[d.variantSet].standardCount++;
      } else {
        variantSets[d.variantSet].variants[d.variant] = (variantSets[d.variantSet].variants[d.variant] || 0) + 1;
      }
    });
    return Object.entries(variantSets).map(([setName, data]) => {
      const chartData = Object.entries(data.variants).map(([vName, count]) => ({
        name: vName,
        value: count
      })).sort((a, b) => b.value - a.value);
      return {
        name: setName,
        chartData,
        standardCount: data.standardCount
      };
    }).sort((a, b) => b.chartData.length - a.chartData.length);
  }, [filteredData, selectedRoom]);
  const handleClearFilters = () => {
    setModelFilter('All Models');
  };
  // ─── Widget Renderers ───────────────────────────────────────────────────────
  const renderKpiCards = () => <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3175">
      <Card data-id="element-3176">
        <CardContent className="p-6 flex items-center gap-4" data-id="element-3177">
          <div className="p-3 bg-primary-50 rounded-lg" data-id="element-3178">
            <Layers className="h-6 w-6 text-primary-600" data-id="element-3179" />
          </div>
          <div data-id="element-3180">
            <p className="text-sm font-medium text-slate-500" data-id="element-3181">
              Total Selections
            </p>
            <h3 className="text-2xl font-bold text-slate-900" data-id="element-3182">
              {kpis.totalSelections}
            </h3>
          </div>
        </CardContent>
      </Card>
      <Card data-id="element-3183">
        <CardContent className="p-6 flex items-center gap-4" data-id="element-3184">
          <div className="p-3 bg-emerald-50 rounded-lg" data-id="element-3185">
            <Users className="h-6 w-6 text-emerald-600" data-id="element-3186" />
          </div>
          <div data-id="element-3187">
            <p className="text-sm font-medium text-slate-500" data-id="element-3188">Unique Buyers</p>
            <h3 className="text-2xl font-bold text-slate-900" data-id="element-3189">
              {kpis.uniqueBuyers}
            </h3>
          </div>
        </CardContent>
      </Card>
      <Card data-id="element-3190">
        <CardContent className="p-6 flex items-center gap-4" data-id="element-3191">
          <div className="p-3 bg-blue-50 rounded-lg" data-id="element-3192">
            <Home className="h-6 w-6 text-blue-600" data-id="element-3193" />
          </div>
          <div data-id="element-3194">
            <p className="text-sm font-medium text-slate-500" data-id="element-3195">Models Active</p>
            <h3 className="text-2xl font-bold text-slate-900" data-id="element-3196">
              {kpis.modelsActive}
            </h3>
          </div>
        </CardContent>
      </Card>
      <Card data-id="element-3197">
        <CardContent className="p-6 flex items-center gap-4" data-id="element-3198">
          <div className="p-3 bg-slate-100 rounded-lg" data-id="element-3199">
            <Database className="h-6 w-6 text-slate-600" data-id="element-3200" />
          </div>
          <div className="min-w-0" data-id="element-3201">
            <p className="text-sm font-medium text-slate-500" data-id="element-3202">
              Top Option Type
            </p>
            <h3 className="text-lg font-bold text-slate-900 truncate" title={kpis.topOptionType} data-id="element-3203">
              {kpis.topOptionType}
            </h3>
          </div>
        </CardContent>
      </Card>
    </div>;
  const renderBarChartHorizontal = (data: {
    name: string;
    value: number;
  }[], height: number, barColor: string) => <ResponsiveContainer width="100%" height={height} data-id="element-3204">
      <BarChart data={data} layout="vertical" data-id="element-3205">
        <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e2e8f0" data-id="element-3206" />
        <XAxis type="number" hide data-id="element-3207" />
        <YAxis dataKey="name" type="category" width={140} tick={{
        fill: '#64748b',
        fontSize: 11
      }} data-id="element-3208" />
        <Tooltip contentStyle={{
        borderRadius: '8px',
        border: 'none',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
      }} data-id="element-3209" />
        <Bar dataKey="value" fill={barColor} radius={[0, 4, 4, 0]} barSize={20} name="Count" data-id="element-3210" />
      </BarChart>
    </ResponsiveContainer>;
  const renderPieChartView = (data: {
    name: string;
    value: number;
  }[], height: number) => <ResponsiveContainer width="100%" height={height} data-id="element-3211">
      <PieChart data-id="element-3212">
        <Pie data={data} cx="50%" cy="50%" outerRadius={height * 0.35} dataKey="value" label={renderPieLabel} labelLine={{
        stroke: '#94a3b8',
        strokeWidth: 1
      }} strokeWidth={2} stroke="#fff" data-id="element-3213">
          {data.map((_, index) => <Cell key={index} fill={PIE_COLORS[index % PIE_COLORS.length]} data-id="element-3214" />)}
        </Pie>
        <Tooltip contentStyle={{
        borderRadius: '8px',
        border: 'none',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
      }} data-id="element-3215" />
      </PieChart>
    </ResponsiveContainer>;
  const renderTopVariants = () => <Card data-id="element-3216">
      <CardHeader data-id="element-3217">
        <CardTitle data-id="element-3218">Top Variant Selections</CardTitle>
      </CardHeader>
      <CardContent data-id="element-3219">
        <div className="h-[300px] w-full" data-id="element-3220">
          {chartType === 'bar' ? renderBarChartHorizontal(allRoomsData.topVariants, 300, '#475569') : renderPieChartView(allRoomsData.topVariants, 300)}
        </div>
      </CardContent>
    </Card>;
  const renderSummaryTable = () => <Card noPadding data-id="element-3221">
      <CardHeader className="border-b border-slate-200 bg-slate-50" data-id="element-3222">
        <CardTitle data-id="element-3223">Selection Summary</CardTitle>
        <p className="text-xs text-slate-400 mt-1" data-id="element-3224">Top 15 selections</p>
      </CardHeader>
      <div className="overflow-x-auto" data-id="element-3225">
        <table className="w-full text-left text-sm" data-id="element-3226">
          <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-3227">
            <tr data-id="element-3228">
              <th className="px-4 py-3" data-id="element-3229">Room</th>
              <th className="px-4 py-3" data-id="element-3230">Option</th>
              <th className="px-4 py-3 text-right" data-id="element-3231">#</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-3232">
            {allRoomsData.summaryTable.map((item, index) => <tr key={index} className="hover:bg-slate-50" data-id="element-3233">
                <td className="px-4 py-3 text-slate-600" data-id="element-3234">
                  {toSentenceCase(item.lvsName)}
                </td>
                <td className="px-4 py-3 text-slate-900" data-id="element-3235">
                  {toSentenceCase(item.variant)}
                </td>
                <td className="px-4 py-3 text-right font-medium text-slate-700" data-id="element-3236">
                  {item.count}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
  const renderRoomCharts = () => <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3237">
      {specificRoomData.map(variantSet => <Card key={variantSet.name} data-id="element-3238">
          <CardHeader data-id="element-3239">
            <CardTitle className="text-base" data-id="element-3240">
              {toSentenceCase(variantSet.name)}
            </CardTitle>
          </CardHeader>
          <CardContent data-id="element-3241">
            {variantSet.chartData.length > 0 ? <div className="h-[180px] w-full" data-id="element-3242">
                {chartType === 'bar' ? <ResponsiveContainer width="100%" height="100%" data-id="element-3243">
                    <BarChart layout="vertical" data={variantSet.chartData} margin={{
              top: 0,
              right: 30,
              left: 0,
              bottom: 0
            }} data-id="element-3244">
                      <XAxis type="number" hide data-id="element-3245" />
                      <YAxis dataKey="name" type="category" width={120} tick={{
                fill: '#64748b',
                fontSize: 10
              }} interval={0} data-id="element-3246" />
                      <Tooltip cursor={{
                fill: 'transparent'
              }} contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-3247" />
                      <Bar dataKey="value" fill="#06b6d4" radius={[0, 4, 4, 0]} barSize={20} label={{
                position: 'right',
                fill: '#334155',
                fontSize: 11,
                fontWeight: 600
              }} data-id="element-3248" />
                    </BarChart>
                  </ResponsiveContainer> : renderPieChartView(variantSet.chartData, 180)}
              </div> : <div className="h-[180px] flex items-center justify-center text-sm text-slate-400 italic" data-id="element-3249">
                No upgrade selections
              </div>}
            {variantSet.standardCount > 0 && <p className="text-xs text-slate-400 italic mt-2 text-center" data-id="element-3250">
                (+{variantSet.standardCount} standard selections)
              </p>}
          </CardContent>
        </Card>)}
    </div>;
  // ─── Widget Order Map ─────────────────────────────────────────────────────────
  // Map widget IDs to their render functions for the "All Rooms" view
  const allRoomsWidgetMap: Record<string, () => React.ReactNode> = {
    'top-variants': renderTopVariants,
    'summary-table': renderSummaryTable
  };
  // For specific room view, room-charts is the only relevant widget
  // KPI cards are always above the room section
  // ─── Render ───────────────────────────────────────────────────────────────────
  const hasCustomization = widgets.some((w, i) => !w.visible || w.id !== DEFAULT_WIDGETS[i]?.id);
  // Check if there's insufficient data (or force empty state for testing)
  const hasInsufficientData = forceEmptyState || kpis.totalSelections < 10 || kpis.uniqueBuyers < 3;
  return <div className="space-y-8 max-w-7xl mx-auto pb-12" data-id="element-3251">
      {/* Empty State */}
      {hasInsufficientData && <div className="relative" data-id="element-3252">
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-3253">
            <div data-id="element-3254">
              <div className="flex items-center gap-3 mb-1" data-id="element-3255">
                <h1 className="text-2xl font-bold text-slate-900" data-id="element-3256">
                  Buyer Selections
                </h1>
                <Badge variant="neutral" data-id="element-3257">
                  {kpis.totalSelections} selections
                </Badge>
              </div>
              <p className="text-slate-500" data-id="element-3258">
                Real selection data from active buyers
              </p>
            </div>
          </div>

          {/* Empty State Content */}
          <div className="relative" data-id="element-3259">
            {/* Blurred Preview Charts */}
            <div className="pointer-events-none select-none blur-sm opacity-90 space-y-6" data-id="element-3260">
              {/* KPI Cards Preview */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3261">
                {[1, 2, 3, 4].map(i => <Card key={i} data-id="element-3262">
                    <CardContent className="p-6" data-id="element-3263">
                      <div className="h-16 bg-slate-200 rounded animate-pulse" data-id="element-3264" />
                    </CardContent>
                  </Card>)}
              </div>

              {/* Charts Preview */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-3265">
                <Card data-id="element-3266">
                  <CardHeader data-id="element-3267">
                    <div className="h-6 w-48 bg-slate-200 rounded animate-pulse" data-id="element-3268" />
                  </CardHeader>
                  <CardContent data-id="element-3269">
                    <div className="h-64 bg-slate-100 rounded" data-id="element-3270" />
                  </CardContent>
                </Card>
                <Card data-id="element-3271">
                  <CardHeader data-id="element-3272">
                    <div className="h-6 w-48 bg-slate-200 rounded animate-pulse" data-id="element-3273" />
                  </CardHeader>
                  <CardContent data-id="element-3274">
                    <div className="h-64 bg-slate-100 rounded" data-id="element-3275" />
                  </CardContent>
                </Card>
              </div>
            </div>

            {/* Centered Message */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-3276">
              <Card className="max-w-md mx-4 shadow-xl border-2 border-slate-200" data-id="element-3277">
                <CardContent className="p-8 text-center" data-id="element-3278">
                  <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3279">
                    <Database className="h-8 w-8 text-slate-400" data-id="element-3280" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-3281">
                    Not Enough Data Yet
                  </h3>

                  {showGenericEmpty ? <>
                      <p className="text-sm text-slate-500 mb-6" data-id="element-3282">
                        We need more buyer selections and unique buyers to
                        generate meaningful insights.
                      </p>
                      <p className="text-xs text-slate-400" data-id="element-3283">
                        Charts and insights will appear automatically once you
                        reach the minimum thresholds.
                      </p>
                    </> : <>
                      <p className="text-sm text-slate-500 mb-6" data-id="element-3284">
                        We need at least <strong data-id="element-3285">10 buyer selections</strong>{' '}
                        and <strong data-id="element-3286">3 unique buyers</strong> to generate
                        meaningful insights.
                      </p>
                      <div className="space-y-2 text-left bg-slate-50 rounded-lg p-4 border border-slate-200" data-id="element-3287">
                        <div className="flex items-center justify-between text-sm" data-id="element-3288">
                          <span className="text-slate-600" data-id="element-3289">
                            Current Selections:
                          </span>
                          <span className="font-semibold text-slate-900" data-id="element-3290">
                            {kpis.totalSelections} / 10
                          </span>
                        </div>
                        <div className="w-full bg-slate-200 rounded-full h-2" data-id="element-3291">
                          <div className="bg-primary-500 h-2 rounded-full transition-all" style={{
                      width: `${Math.min(kpis.totalSelections / 10 * 100, 100)}%`
                    }} data-id="element-3292" />
                        </div>
                        <div className="flex items-center justify-between text-sm pt-2" data-id="element-3293">
                          <span className="text-slate-600" data-id="element-3294">Unique Buyers:</span>
                          <span className="font-semibold text-slate-900" data-id="element-3295">
                            {kpis.uniqueBuyers} / 3
                          </span>
                        </div>
                        <div className="w-full bg-slate-200 rounded-full h-2" data-id="element-3296">
                          <div className="bg-emerald-500 h-2 rounded-full transition-all" style={{
                      width: `${Math.min(kpis.uniqueBuyers / 3 * 100, 100)}%`
                    }} data-id="element-3297" />
                        </div>
                      </div>
                      <p className="text-xs text-slate-400 mt-4" data-id="element-3298">
                        Charts and insights will appear automatically once you
                        reach the minimum thresholds.
                      </p>
                    </>}
                </CardContent>
              </Card>
            </div>
          </div>
        </div>}

      {/* Normal Content - Only show when there's sufficient data */}
      {!hasInsufficientData && <>
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-3299">
            <div data-id="element-3300">
              <div className="flex items-center gap-3 mb-1" data-id="element-3301">
                <h1 className="text-2xl font-bold text-slate-900" data-id="element-3302">
                  Buyer Selections
                </h1>
                <Badge variant="default" data-id="element-3303">
                  {filteredData.length} selections
                </Badge>
              </div>
              <p className="text-slate-500" data-id="element-3304">
                Real selection data from active buyers
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-3305">
              <ChartTypeToggle value={chartType} onChange={setChartType} data-id="element-3306" />

              <div className="relative" ref={customizeRef} data-id="element-3307">
                <Button variant={hasCustomization ? 'primary' : 'outline'} leftIcon={<SlidersHorizontal className="h-4 w-4" data-id="element-3309" />} onClick={() => setCustomizeOpen(!customizeOpen)} data-id="element-3308">
                  Customize
                </Button>
                {customizeOpen && <CustomizePanel widgets={widgets} onToggle={handleToggleWidget} onReorder={handleReorderWidgets} onReset={handleResetWidgets} onClose={() => setCustomizeOpen(false)} data-id="element-3310" />}
              </div>

              <Button variant="outline" leftIcon={<Download className="h-4 w-4" data-id="element-3312" />} data-id="element-3311">
                Export Data
              </Button>
            </div>
          </div>

          {/* Filter Bar */}
          <Card data-id="element-3313">
            <CardContent className="p-4" data-id="element-3314">
              <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center" data-id="element-3315">
                <div className="flex items-center gap-2 text-slate-500 text-sm font-medium min-w-fit" data-id="element-3316">
                  <Filter className="h-4 w-4" data-id="element-3317" />
                  Filters:
                </div>
                <div className="w-full max-w-xs" data-id="element-3318">
                  <select value={modelFilter} onChange={e => setModelFilter(e.target.value)} className="w-full px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-3319">
                    <option value="All Models" data-id="element-3320">All Models</option>
                    <option value="Bellevue" data-id="element-3321">
                      {toSentenceCase('Bellevue')}
                    </option>
                    <option value="Collingwood" data-id="element-3322">
                      {toSentenceCase('Collingwood')}
                    </option>
                  </select>
                </div>
                <Button variant="ghost" onClick={handleClearFilters} className="whitespace-nowrap" leftIcon={<X className="h-4 w-4" data-id="element-3324" />} data-id="element-3323">
                  Clear Filters
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* KPI Cards */}
          {isWidgetVisible('kpi-cards') && renderKpiCards()}

          {/* Options by Room Section */}
          {(isWidgetVisible('top-variants') || isWidgetVisible('summary-table') || isWidgetVisible('room-charts')) && <div className="flex flex-col lg:flex-row gap-6 items-start" data-id="element-3325">
              {/* Left Nav */}
              <div className="w-52 flex-shrink-0" data-id="element-3326">
                <Card className="h-full" noPadding data-id="element-3327">
                  <div className="p-4 border-b border-slate-200" data-id="element-3328">
                    <h2 className="font-semibold text-slate-900" data-id="element-3329">Categories</h2>
                  </div>
                  <nav className="p-2 space-y-1" data-id="element-3330">
                    <button onClick={() => setSelectedRoom('All Rooms')} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-colors ${selectedRoom === 'All Rooms' ? 'bg-primary-50 text-primary-700 font-medium' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-3331">
                      <span data-id="element-3332">All Categories</span>
                    </button>
                    {roomNavData.map(room => <button key={room.name} onClick={() => setSelectedRoom(room.name)} className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-sm transition-colors ${selectedRoom === room.name ? 'bg-primary-50 text-primary-700 font-medium' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-3333">
                        <span className="truncate" data-id="element-3334">
                          {toSentenceCase(room.name)}
                        </span>
                        <Badge variant="neutral" className="ml-2 text-xs" data-id="element-3335">
                          {room.count}
                        </Badge>
                      </button>)}
                  </nav>
                </Card>
              </div>

              {/* Right Content */}
              <div className="flex-1 w-full space-y-6" data-id="element-3336">
                {selectedRoom === 'All Rooms' ? (() => {
            // Render top-variants and summary-table in widget order
            const allRoomsWidgets = widgets.filter(w => (w.id === 'top-variants' || w.id === 'summary-table') && w.visible);
            if (allRoomsWidgets.length === 0) {
              return <div className="text-center py-16 text-slate-400" data-id="element-3337">
                          <SlidersHorizontal className="h-8 w-8 mx-auto mb-3 text-slate-300" data-id="element-3338" />
                          <p className="text-sm" data-id="element-3339">
                            All chart widgets are hidden.
                          </p>
                          <p className="text-xs mt-1" data-id="element-3340">
                            Use the Customize button to show them.
                          </p>
                        </div>;
            }
            // If both visible, show in a 2-col grid respecting order
            if (allRoomsWidgets.length === 2) {
              return <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-3341">
                          {allRoomsWidgets.map(w => <div key={w.id} data-id="element-3342">{allRoomsWidgetMap[w.id]()}</div>)}
                        </div>;
            }
            // Only one visible — full width
            return <div data-id="element-3343">
                        {allRoomsWidgets.map(w => <div key={w.id} data-id="element-3344">{allRoomsWidgetMap[w.id]()}</div>)}
                      </div>;
          })() : isWidgetVisible('room-charts') ? renderRoomCharts() : <div className="text-center py-16 text-slate-400" data-id="element-3345">
                    <SlidersHorizontal className="h-8 w-8 mx-auto mb-3 text-slate-300" data-id="element-3346" />
                    <p className="text-sm" data-id="element-3347">Room charts are hidden.</p>
                    <p className="text-xs mt-1" data-id="element-3348">
                      Use the Customize button to show them.
                    </p>
                  </div>}
              </div>
            </div>}
        </>}
    </div>;
}